<template>
    <div>
        <b-card no-body class="page-card">
            <b-card-header class="mx-3 px-0 d-flex align-items-center justify-content-between">
                <div class="title">
                    <i class="fa fa-align-justify mr-2"></i> {{ trans.title }}
                </div>

                <div class="action-buttons">
                    <div class="dropdown btn-group">
                        <a target="_blank" :href="this.url + '/' + this.currentYear + '/export?orderBy=' + this.orderBy.column + '&orderDirection=' + this.orderBy.direction  + '&status=' + this.filters.status + '&absence=' + this.filters.absence" class="btn btn-dark">
                            <i class="fal fa-fw fa-file-pdf mr-1"></i> <span class="hidden-sm-down">{{ trans.actions.print_card }} (PDF)</span>
                        </a>
                        <button type="button" class="btn btn-secondary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>
                        <div class="dropdown-menu bg-dark pl-1">
                            <a target="_blank" :href="this.url + '/' + this.currentYear + '/export?orderBy=' + this.orderBy.column + '&orderDirection=' + this.orderBy.direction" class="btn btn-dark d-block pl-2 text-left"><i class="fal fa-fw fa-file-pdf mr-1"></i> <span class="hidden-sm-down">{{ trans.actions.print_card }} (PDF)</span></a>
                            <a target="_blank" :href="this.url + '/' + this.currentYear + '/export/xlsx?orderBy=' + this.orderBy.column + '&orderDirection=' + this.orderBy.direction" class="btn btn-dark d-block pl-2 text-left"><i class="fal fa-fw fa-file-excel mr-1"></i> <span class="hidden-sm-down">{{ trans.actions.print_card }} (XLSX)</span></a>
                        </div>
                    </div>
                </div>                
            </b-card-header>

            <b-card-body>

                <div class="form-group">
                    <form @submit.prevent="">
                        <div class="row justify-content-md">
                            <div class="col-12 col-sm-3 col-lg-2 mb-0 form-group compact">
                                <div class="input-group">
                                    <select class="form-control" v-model="filters.status" @change="filter('status', $event.target.value)">
                                        <option value="all">{{ trans.statuses.all }}</option>
                                        <option v-for="(status, key) in statuses" :key="key" :value="status">{{ trans.statuses[status] }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-12 col-sm-3 col-lg-2 mb-0 form-group compact">
                                <div class="input-group">
                                    <select class="form-control" v-model="filters.absence" @change="filter('absence', $event.target.value)">
                                        <option value="all">{{ trans.hours.all }}</option>
                                        <option value="no_absence">{{ trans.hours.no_absence }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-12 col-sm-3 col-lg-2 mb-0 form-group">
                                <div class="input-group">
                                    <button type="button" v-if="isFiltered()" class="btn btn-danger" @click="resetFilter(); filter()">
                                        <i class="fa fa-trash-alt"></i> <span class="hidden-sm-down">{{ trans.btn.delete_filter }}</span>
                                    </button>
                                </div>
                            </div>

                            <div class="form-group ml-auto mb-0 pr-3">
                            	<dropdown-years
                                    class="select-month"
                                    :year="currentYear"
                                    :years-count="5"
                                    :year-start="2020"
                                    :choose-action="chooseYear"
                                    :show-buttons="true"
                                    :loading="loading"
                                    style="justify-content: flex-end"
                                ></dropdown-years>
                            </div>
                        </div>
                    </form>

                </div>
                
                <div class="loading-box" v-if="loading" style="height: 70vh">
                    <div class="loading-inner"><i class="fa fa-spin fa-circle-notch text-secondary"></i></div>
                </div>

                <div v-if="!loading">
                    <div class="table-responsive table-scrollable" v-if="!loading" :style="{ height: getTableScrollableHeight(105) }" v-cloak>

                        <table class="table table-hover">

                            <thead>
                                <tr>
                                    <th is='sortable' :column="'last_name'">{{ trans.columns.name }}</th>
                                    <th v-for="(contractType, key) in contractTypes" :key="key" class="text-center" is='sortable' :column="'' + contractType.id">{{ contractType.shortcode }}</th>
                                    <th class="text-center" is='sortable' :column="'total_hours'">{{ trans.columns.total }}</th>
                                    <th class="text-center"></th>
                                </tr>
                            </thead>

                            <tbody>
                                
                                <tr v-if="yearlyStats.length == 0">
                                    <td :colspan ="contractTypes.length + 1" class="text-center text-muted py-5 bg-white"><em>{{ trans.empty_data_msg }}</em></td>
                                </tr>

                                <tr v-for="(employee, ekey) in yearlyStats" :key="ekey">
                                    <td>
                                        <span class="employee-name-label">
                                            {{ employee.name }}
                                        </span>
                                    </td>
                                    <td v-for="(contractType, ckey) in contractTypes" :key="ckey" class="text-center">{{ employee.contractTypes[contractType.id].toFixed(2)}} {{ trans.common.hours_abbr }}</td>
                                    <td class="text-center">{{ employee.total_hours.toFixed(2) }} {{ trans.common.hours_abbr }}</td>
                                    <td>
                                        <a :href="getEmployeeDetailUrl(employee.id)" rel=opener target="_blank" :title="trans.btn.show_employee" class="btn btn-spinner btn-success">
                                            <i class="far fa-fw fa-user"></i>
                                        </a>
                                    </td>
                                </tr>

                            </tbody>

                        </table>
                    
                    </div>
                </div>

            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import AppListing from '../../app-components/Listing/AppListing'

export default {
    name: "YearlyReport",
    mixins: [AppListing],

    data() {
        return {
            loading: false,
            currentYear: this.year,
            yearlyStats: [],
            orderBy: {
                column: 'last_name',
                direction: 'asc'
            },
            filters: {
                status: 'all',
                absence: 'all'
            }
        };
    },
    props: {
        "year": {
            type: Number
        },
        "trans": {
            type: Object
        },
        "contractTypes": {
            type: Array
        },
        'url': {
            type: String
        },
        'statuses': {
            type: Array
        }
    },
    methods:{
        chooseYear(year) {
            this.currentYear = year;
            this.loadData();
        },
        loadData() {
            this.loading = true;
            var _this = this;

            var options = {
                params: {
                    orderBy: this.orderBy.column,
                    orderByCT: this.orderBy.contractType,
                    orderDirection: this.orderBy.direction,
                    status: this.filters.status,
                    absence: this.filters.absence
                }
            };

            axios.get("yearly-report/"+this.currentYear, options).then(response => {
                if(response && response.data)
                {
                    this.yearlyStats = response.data;
                    _this.loading = false;
                }
            }, function (error) {
                _this.$notify({ type: 'error', title: 'Error!', text: error.response.data.message ? error.response.data.message : 'An error has occured.' });
                _this.loading = false;
            });
        },

        resetFilter() {
            this.filters.status='all'; 
            this.filters.absence='all'; 
        },
        
        isFiltered() {
            if(this.filters.status !='all' || this.filters.absence != 'all')
            {
                return 1;
            } 
            else
            {
                return 0;
            }            
        },

        getEmployeeDetailUrl(employeeId) {
            return '/employees/'+employeeId+'/show';
        }
    }
} 
</script>


// WEBPACK FOOTER //
// resources/assets/admin/js/report/yearly-report/YearlyReport.vue